export default __webpack_public_path__ + "static/media/n-back-visivo-step1.c4117023.svg";